import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { ApiError } from './api.js';

/**
 * Convenience wrapper around useQuery that disables retries on 401 (so
 * an expired Access cookie shows the UnauthorizedState immediately
 * rather than spinning).
 */
export function useApiQuery<TData>(
  opts: Omit<UseQueryOptions<TData, ApiError | Error>, 'retry'>,
) {
  return useQuery<TData, ApiError | Error>({
    ...opts,
    retry: (failureCount, err) => {
      if (err instanceof ApiError && err.isUnauthorized()) return false;
      return failureCount < 1;
    },
  });
}
